<div class="d-flex justify-content-center flex-column align-items-center">
    <div class="w-25">
        <div class="d-flex flex-column align-items-center">
            <button type="button" mat-fab extended color="primary" (click)="fileInput.click()" class="mt-3 no-shadow" [disabled]="isFileUploading">
                <mat-icon class="mr-3">upload</mat-icon>
                Subir Archivo
                <mat-icon *ngIf="isFileUploading" iconPositionEnd>
                    <mat-spinner class="custom-white-spinner" diameter="20"></mat-spinner>
                </mat-icon>
            </button>
            <p class="hint-text">Solo se permiten archivos PDF, JPG</p>
        </div>

        <input #fileInput hidden type="file" (change)="onFileSelected($event)" accept=".pdf, .jpg, .jpeg" />

        <mat-list role="list" class="w-100">
            <ng-container *ngFor="let file of files">
                <mat-list-item class="px-0">
                    <div class="d-flex justify-content-between align-items-center">
                        <span>{{ file.displayName }}</span>
                        <div>
                            <button mat-icon-button color="warn" (click)="deleteFile(file)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button mat-icon-button color="primary" (click)="seePDF(file.url)">
                                <mat-icon>visibility</mat-icon>
                            </button>
                        </div>
                        
                    </div>
                </mat-list-item>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-list>
    </div>
</div>
